// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ISuggestV2ResponseSchema } from '../../entities/entities/SuggestV2ResponseSchema';
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface ISuggestRequest {
  /**  Тип сделки  **/
  dealType?: EQueryParameters;
  /**  Идет ли поиск коворкингов  **/
  isCoworkingSearch?: boolean;
  /** Идет ли поиск для посутки  **/
  isDailyRent?: boolean;
  /**  Тип недвижимости  **/
  offerType: EQueryParameters_1;
  /**  Запрос пользователя  **/
  query: string;
  /**  id региона  **/
  regionId: number;
  /**  Откуда пришел запрос  **/
  source?: EQueryParameters_2;
}

export enum EQueryParameters {
  /** Аренда **/
  'Rent' = 'rent',
  /** Покупка **/
  'Sale' = 'sale',
}
export enum EQueryParameters_1 {
  /** Коммерческая **/
  'Commercial' = 'commercial',
  /** Квартиры **/
  'Flat' = 'flat',
  /** Новостройки **/
  'Newobject' = 'newobject',
  /** Загородка **/
  'Suburban' = 'suburban',
}
export enum EQueryParameters_2 {
  /** Из коммерческой недвижимости **/
  'IapMap' = 'iapMap',
  /** С главной **/
  'Mainpage' = 'mainpage',
  /** С карты **/
  'Map' = 'map',
  /** С мобильного сайта **/
  'MobileWebsite' = 'mobileWebsite',
  /** Страница акций в новостройках **/
  'NewbuildingPromosPage' = 'newbuildingPromosPage',
  /** С поиска **/
  'Serp' = 'serp',
}
export type TSuggestResponse_1 = ISuggestV2ResponseSchema;

export interface ISuggestResponse200 extends IModelResponse<TSuggestResponse_1> {
  statusCode: 200;
}

export type TSuggestResponseError = IErrorResponseSchema;

export interface ISuggestResponse400 extends IModelResponse<TSuggestResponseError> {
  statusCode: 400;
}

export type TSuggestResponse = ISuggestResponse200 | ISuggestResponse400;

export type TSuggestModel = IModel<ISuggestRequest, TSuggestResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: TSuggestResponse_1): TResponse200;
  400(response: TSuggestResponseError): TResponse400;
}
